import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Register.css";
import { useHistory, Link } from "react-router-dom";

const Register = () => {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [inputs, setInputs] = useState({
    username: "",
    password: "",
    confirmPassword: ""
  });
  const [isCallingAPI, setIsCallingAPI] = useState(false);

  const handleChange = (e) =>{
    // console.log(e.target);
    setInputs((prevState) => ({
      ...prevState,
      [e.target.name] : e.target.value
    }))
  }

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement the register function


// const Register = () => {
//   const { enqueueSnackbar } = useSnackbar();


  /**
   * Definition for register handler
   * - Function to be called when the user clicks on the register button or submits the register form
   *
   * @param {{ username: string, password: string, confirmPassword: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/register"
   *
   * Example for successful response from backend for the API call:
   * HTTP 201
   * {
   *      "success": true,
   * }
   *
   * Example for failed response from backend for the API call:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Username is already taken"
   * }
   */
  const register = async (formData) => {
    // console.log(formData);
    const body = {
      username: formData.username,
      password: formData.password
    }
    // console.log(config);
    // console.log(config.endpoint);
    // console.log(`${config.endpoint}/auth/register`);
    try{
      const response = await axios.post(`${config.endpoint}/auth/register`, body);
      console.log('Post request succeeded:', response);
      setIsCallingAPI(false);
      enqueueSnackbar('Registered successfully', { variant: 'success' });
      history.push('/login');
    } catch (error){
      if (error.response){
        if(error.response.status.toString()[0]==='4')
        {
        // console.log('400 type error');
        enqueueSnackbar(error.response.data.message, { variant: 'error' });
        }
      } else{
        enqueueSnackbar('Something went wrong. Check that the backend is running, reachable and returns valid JSON.', { variant: 'error' });
      }
      setIsCallingAPI(false);
      // console.log(error.response);
      // console.log(error.response.status);
      // console.log(error.response.data.message);
      
    }
  } 



  // TODO: CRIO_TASK_MODULE_REGISTER - Implement user input validation logic
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string, confirmPassword: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that username field is not less than 6 characters in length - "Username must be at least 6 characters"
   * -    Check that password field is not an empty value - "Password is a required field"
   * -    Check that password field is not less than 6 characters in length - "Password must be at least 6 characters"
   * -    Check that confirmPassword field has the same value as password field - Passwords do not match
   */
  const validateInput = (data) => {
    // console.log(data);
    const {username, password, confirmPassword} = data;
    // console.log(username, password, confirmPassword);
    if(username.length === 0){
      enqueueSnackbar('Username is a required field', { variant: 'warning' });
      return false;
    }
    if(username.length < 6){
      enqueueSnackbar('Username must be at least 6 characters', { variant: 'warning' });
      return false;
    }
    if(password.length === 0){
      enqueueSnackbar('Password is a required field', { variant: 'warning' });
      return false;
    }
    if(password.length < 6){
      enqueueSnackbar('Password must be at least 6 characters', { variant: 'warning' });
      return false;
    }
    if(password !== confirmPassword){
      enqueueSnackbar('Passwords do not match', { variant: 'warning' });
      return false;
    }
    return true;
  };

  
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons />
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className="title">Register</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            fullWidth
            value={inputs.username}
            onChange = {handleChange}
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            helperText="Password must be atleast 6 characters length"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
            value={inputs.password}
            onChange = {handleChange}

          />
          <TextField
            id="confirmPassword"
            variant="outlined"
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            fullWidth
            value={inputs.confirmPassword}
            onChange = {handleChange}

          />
          <Box display="flex" justifyContent="center">
          {isCallingAPI ? <CircularProgress /> : (<Button
            className="button"
            variant="contained"
            type="submit"
            fullWidth
            onClick={(e) => {
              // console.log("Form Submitted");
              // console.log(inputs);
              if(validateInput(inputs)){
                setIsCallingAPI(true);
                register(inputs);
              }
            }}
          >
            Register Now
          </Button>)}
          </Box>
          
         
          
          <p className="secondary-action">
            Already have an account?{" "}
            <Link className="link" to='/login' >Login here</Link>
            {/* <a className="link" href="#">
              Login here
            </a> */}
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Register;
